import { FC, useContext } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useParams,
  useLocation,
} from 'react-router-dom';

import { NavigationContext } from 'context/NavigationContext';
import AppLayout from 'layout/AppLayout';
import BasicInfo from 'modules/home/pages/BasicInfo/BasicInfo';
import { routes } from 'routes';
import PrivateRoute from 'routes/PrivateRoute';
import RouteMap from 'routes/RouteMap';
import ErrorBoundary from 'modules/auth/pages/ErrorBoundary/ErrorBoundary';
import PlanRecommender from 'modules/planRecommender/pages/PlanRecommender/PlanRecommender';
import PlanRecommenderLayout from 'modules/planRecommender/components/PlanRecommenderLayout/PlanRecommenderLayout';
import useBenguide from 'hooks/benguide';
import OAuthCallback from 'modules/auth/pages/OAuthCallback/OAuthCallback';
import CustomPage from 'modules/customPages/pages/CustomPage/CustomPage';

const AppRoutes: FC = () => {
  const { disabledRoutes } = useContext(NavigationContext);
  const { planRecommenderEnabled } = useBenguide();

  const RedirectVoluntary = () => {
    const { hash, employerName } = useParams();
    const location = useLocation();

    const redirectPath = employerName
      ? `/${hash}/${employerName}/worksite`
      : `/${hash}/worksite`;
    const fullRedirectPath = `${redirectPath}${location.search}`;
    return <Navigate to={fullRedirectPath} replace />;
  };

  return (
    <Routes>
      {/* Add a top-level route for OAuth callback */}
      <Route path="/auth/callback" element={<OAuthCallback />} />

      <Route path={RouteMap.CREATE_BENGUIDE} element={<AppLayout />}>
        <Route path="" element={<BasicInfo />} />
      </Route>
      <Route path="/:hash">
        {planRecommenderEnabled && (
          <Route
            path="plan-recommender"
            element={<PrivateRoute layout={PlanRecommenderLayout} />}
          >
            <Route path="medical" element={<PlanRecommender />} />
          </Route>
        )}
      </Route>
      <Route path="/:hash/:employerName">
        {planRecommenderEnabled && (
          <Route
            path="plan-recommender"
            element={<PrivateRoute layout={PlanRecommenderLayout} />}
          >
            <Route path="medical" element={<PlanRecommender />} />
          </Route>
        )}
      </Route>
      <Route path="/:hash" element={<PrivateRoute />}>
        {routes
          .filter((route) => !disabledRoutes.includes(route.path))
          .map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        {/* Dynamic route for custom pages */}
        <Route path="custom-page/:customPageId" element={<CustomPage />} />
        <Route path="voluntary" element={<RedirectVoluntary />} />
        <Route path="*" element={<ErrorBoundary />} />
      </Route>
      <Route path="/:hash/:employerName" element={<PrivateRoute />}>
        {routes
          .filter((route) => !disabledRoutes.includes(route.path))
          .map((route) => (
            <Route key={route.path} path={route.path} element={route.element} />
          ))}
        {/* Dynamic route for custom pages */}
        <Route path="custom-page/:customPageId" element={<CustomPage />} />
        <Route path="voluntary" element={<RedirectVoluntary />} />
        <Route path="*" element={<ErrorBoundary />} />
      </Route>
    </Routes>
  );
};

export default AppRoutes;
